/**
 * Custom Select Dropdown - Dark Theme
 * Replaces native <select> with a styleable custom dropdown
 */
(function () {
  function initCustomSelects() {
    const selects = document.querySelectorAll(
      'facet-filters-form .select__select, .facets-vertical-sort .select__select, .globo-form-app select.classic-input',
    );
    selects.forEach(createCustomSelect);
  }

  function createCustomSelect(nativeSelect) {
    if (nativeSelect.dataset.customized) return;
    nativeSelect.dataset.customized = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-select';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    const selectedOption = nativeSelect.options[nativeSelect.selectedIndex];
    trigger.innerHTML = `<span class="custom-select__value">${selectedOption ? selectedOption.text : ''}</span><svg class="custom-select__arrow" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    const dropdown = document.createElement('div');
    dropdown.className = 'custom-select__dropdown';
    dropdown.setAttribute('role', 'listbox');

    Array.from(nativeSelect.options).forEach((opt, i) => {
      const item = document.createElement('div');
      item.className = 'custom-select__option';
      item.setAttribute('role', 'option');
      item.dataset.value = opt.value;
      item.textContent = opt.text;
      if (opt.selected) item.classList.add('selected');

      item.addEventListener('click', function () {
        nativeSelect.value = this.dataset.value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

        trigger.querySelector('.custom-select__value').textContent = this.textContent;
        dropdown.querySelectorAll('.custom-select__option').forEach((o) => o.classList.remove('selected'));
        this.classList.add('selected');
        closeDropdown();
      });
      dropdown.appendChild(item);
    });

    const selectParent =
      nativeSelect.closest('.select') || nativeSelect.closest('.globo-form-input') || nativeSelect.parentNode;
    selectParent.style.position = 'relative';
    selectParent.appendChild(wrapper);
    wrapper.appendChild(trigger);
    wrapper.appendChild(dropdown);

    nativeSelect.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:0;height:0;overflow:hidden;';
    const caret = selectParent.querySelector('.icon-caret');
    if (caret) caret.style.display = 'none';

    function closeDropdown() {
      dropdown.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('open');
      document.querySelectorAll('.custom-select__dropdown.open').forEach((d) => {
        d.classList.remove('open');
        d.previousElementSibling?.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        dropdown.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function () {
      closeDropdown();
    });

    wrapper.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomSelects);
  } else {
    initCustomSelects();
  }

  // Re-init after AJAX filter updates
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(initCustomSelects, 100);
      }
    });
  });

  const target =
    document.getElementById('ProductGridContainer') || document.getElementById('MainContent') || document.body;
  observer.observe(target, { childList: true, subtree: true });
})();
